import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useFetchErrorHandler } from './useLogger';
function fetchListIfNeeded(resource, label, params, options) {
  return (dispatch, getState) => {
    const shouldFetch = resource.selectShouldFetch(getState(), label);
    if (shouldFetch) {
      return dispatch(resource.fetch(resource.options.fetchPath, {
        ...options,
        label,
        params
      }));
    }
    return Promise.resolve();
  };
}
export function useResourceFetch(resource, params, {
  enabled = true,
  ...options
} = {}) {
  const dispatch = useDispatch();
  const handleFetchError = useFetchErrorHandler('useResourceFetch');
  const label = resource.computeLabel(resource.options.fetchPath, {
    ...params,
    ...options.headers
  });
  const summaries = useSelector(state => resource.selectList(state, label));
  const meta = useSelector(state => resource.selectListMeta(state, label));
  const isFailure = useSelector(state => resource.selectIsFailure(state, label));
  const isFetching = useSelector(state => resource.selectIsFetching(state, label));
  const isForbidden = useSelector(state => resource.selectIsFailure(state, {
    label,
    status: 403
  }));
  const isLoaded = useSelector(state => resource.selectIsLoaded(state, label));
  const shouldFetch = useSelector(state => resource.selectShouldFetch(state, label));
  React.useEffect(() => {
    if (shouldFetch && enabled) {
      dispatch(fetchListIfNeeded(resource, label, params, options)).catch(err => {
        handleFetchError(err, `Unable to fetch the ${resource.name} collection.`);
      });
    }
  }, [dispatch, enabled, handleFetchError, label, options, params, resource, shouldFetch]);
  return {
    isFailure,
    isFetching,
    isForbidden,
    isLoaded,
    label,
    shouldFetch,
    summaries,
    meta
  };
}